import * as restaurantSearchActions from '../actions/restaurantSearch'


const initialState = {
  searchText: '',
  searchType: 'restaurantName',
  offset: 0,
  isLoading: false,
  isLoaded: false,
  error: null,
  data: [],
  totalItems: null,
  itemsPerPage: 25,
}

export default (state = initialState, action) => {
  switch (action.type) {

    case restaurantSearchActions.SEARCH_RESTAURANTS_RESET:
      return initialState

    case restaurantSearchActions.SEARCH_RESTAURANTS_REQUESTED:
      return {
        ...state,
        searchText: action.searchText,
        searchType: action.searchType,
        offset: action.offset,
        isLoading: true,
        isLoaded: false
      }

    case restaurantSearchActions.SEARCH_RESTAURANTS_DONE:
      return {
        ...state,
        data: action.foundRestaurants === null ? [] : action.foundRestaurants.data,
        totalItems: action.foundRestaurants === null ? 0 : action.foundRestaurants.totalItems,
        isLoading: false,
        isLoaded: true,
        error: action.error
      }

    case restaurantSearchActions.SEARCH_RESTAURANTS_ERROR:
      return {
        ...state,
        error: action.error,
        isLoading: false,
        isLoaded: true
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/restaurantSearch.js